var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67955 7.84257C9.87646 7.64566 10.1435 7.53503 10.422 7.53503H16.888V11.695C16.888 12.1506 17.069 12.5876 17.3912 12.9098C17.7134 13.232 18.1504 13.413 18.606 13.413H22.626V23.5782C22.6259 23.7161 22.5985 23.8527 22.5456 23.9801C22.4926 24.1074 22.4151 24.2231 22.3174 24.3205C22.2198 24.4179 22.1039 24.4951 21.9763 24.5477C21.8488 24.6003 21.7122 24.6273 21.5743 24.627L21.573 24.627H20.5686L9.49549 8.091C9.54382 8.00037 9.6056 7.91652 9.67955 7.84257ZM9.49546 8.09107C9.49547 8.09104 9.49548 8.09102 9.49549 8.091L8.61889 6.78191C9.0971 6.30369 9.74571 6.03503 10.422 6.03503H17.905H17.9055C18.1292 6.03517 18.3506 6.07995 18.5568 6.16676C18.7627 6.25348 18.9493 6.3804 19.1057 6.54008L19.1062 6.5406L23.6173 11.1397C23.9432 11.4718 24.1259 11.9185 24.126 12.3838V12.384V23.579V23.5799C24.1256 23.9149 24.0593 24.2465 23.9307 24.5558C23.8021 24.8652 23.6138 25.1461 23.3766 25.3827C23.1394 25.6192 22.8579 25.8067 22.5483 25.9344C22.239 26.062 21.9076 26.1274 21.573 26.127L20.5686 24.627H20.5674L9.49546 8.09107ZM9.49546 8.09107C9.41513 8.24174 9.37201 8.41117 9.37201 8.58503V23.577C9.37201 23.8555 9.48263 24.1226 9.67955 24.3195C9.87646 24.5164 10.1435 24.627 10.422 24.627H20.5674L21.5718 26.127L10.422 26.127C9.74571 26.127 9.0971 25.8584 8.61889 25.3802C8.14067 24.9019 7.87201 24.2533 7.87201 23.577V8.58503C7.87201 7.90873 8.14067 7.26013 8.61889 6.78191L9.49546 8.09107ZM22.2746 11.913L18.388 7.95053V11.695C18.388 11.7528 18.411 11.8082 18.4519 11.8491C18.4927 11.89 18.5482 11.913 18.606 11.913H22.2746Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1339 18.0791L27.2552 20.2004",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2551 20.2012L25.1338 22.3225",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.981 20.244H25.97",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDefault);
export default __webpack_public_path__ + "static/media/file-default.c7af7ea5cbf63808eda8857fd806e462.svg";
export { ForwardRef as ReactComponent };